import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en';
import ru from '@/locales/ru';
import it from '@/locales/it';
import { LANGS, DEFAULT_LANG, localeFromPath } from '@/lib/locale';

// The URL decides the language (/, /ru/…, /it/…); see src/lib/locale.js.
const initialLang = typeof window !== 'undefined' ? localeFromPath(window.location.pathname) : DEFAULT_LANG;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
    it: { translation: it },
  },
  lng: initialLang,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: LANGS,
  interpolation: { escapeValue: false },
  returnObjects: false,
});

export default i18n;
